<ng-select
    [items]="displayItems()"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [placeholder]="placeholder"
    [searchable]="searchable"
    [clearable]="clearable"
    [disabled]="disabled"
    [virtualScroll]="virtualScroll"
    [appendTo]="'body'"
    [(ngModel)]="model"
    [ariaLabel]="placeholder"
    (ngModelChange)="onChange($event)"
    (search)="onSearch($event)"
    (close)="onClose()"
    (scrollToEnd)="onScrollToEnd()">
    <ng-template ng-option-tmp let-item="item" let-option="item$">
        @if (item === loaderItem) {
        <span class="select-more">
            <span class="select-more-dot" aria-hidden="true"></span>
            <span class="select-more-dot" aria-hidden="true"></span>
            <span class="select-more-dot" aria-hidden="true"></span>
            <span class="ng-visually-hidden">Loading more items</span>
        </span>
        } @else {
        <span class="ng-option-label">{{ option.label }}</span>
        }
    </ng-template>
</ng-select>
